export enum AgentInputMode {
  None = 'none',
  DeepDiveMode = 'deepDiveMode',
  BuildMode = 'buildMode',
  MultiOrgMode = 'multiOrgMode',
  ArtifactMode = 'artifactMode',
}

